export default __webpack_public_path__ + "static/media/joint_dynamics_banner.212f2eaf.png";